export default "__VITE_ASSET__DDNywxM9__"